import {Button, DatePicker, Form, Input, Select, Space} from "antd";
import {useTranslation} from "react-i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useRef} from "react";

export default function RequestLogFilter()
{
    const {t} = useTranslation();
    const {onFilterPageSort} = useDataGrid();
    const formRef = useRef();

    const reset = () => {
        formRef.current.resetFields();
        onFilterPageSort({
            filter: {}
        })
    }

    const filter = (form) => {
        const {loginStatus, ...rest} = form;
        
        // Transform loginStatus to backend fields
        let loginFilter = {};
        if (loginStatus === 'success') {
            loginFilter = { isLoginAttempt: true, isFailedLogin: false };
        } else if (loginStatus === 'failed') {
            loginFilter = { isLoginAttempt: true, isFailedLogin: true };
        }
        
        const filterData = {
            ...rest,
            ...loginFilter,
            dateFrom: form.dateFrom?.toISOString(),
            dateTo: form.dateTo?.toISOString()
        };
        onFilterPageSort({
            filter: filterData
        })
    }

    const httpMethodOptions = [
        { value: 'GET', label: 'GET' },
        { value: 'POST', label: 'POST' },
        { value: 'PUT', label: 'PUT' },
        { value: 'DELETE', label: 'DELETE' },
        { value: 'PATCH', label: 'PATCH' },
    ];

    const statusCodeOptions = [
        { value: 200, label: '200 - OK' },
        { value: 400, label: '400 - Bad Request' },
        { value: 401, label: '401 - Unauthorized' },
        { value: 403, label: '403 - Forbidden' },
        { value: 404, label: '404 - Not Found' },
        { value: 500, label: '500 - Server Error' },
        { value: 503, label: '503 - Service Unavailable' },
    ];

    const loginStatusOptions = [
        { value: 'all', label: t('All') },
        { value: 'success', label: t('Successful Logins') },
        { value: 'failed', label: t('Failed Logins') },
    ];

    return (
        <>
            <Form
                ref={formRef}
                onFinish={filter}
                layout={'vertical'}
            >
                <Space style={{marginBottom: 16}}>
                    <Button type={'primary'} size={'small'} htmlType="submit">{t('Search')}</Button>
                    <Button size={'small'} onClick={reset}>{t('Reset')}</Button>
                </Space>
                <Form.Item
                    label={t('User')}
                    name={'userName'}
                >
                    <Input placeholder={t('Search by user')} />
                </Form.Item>
                <Form.Item
                    label={t('App Client')}
                    name={'appClientName'}
                >
                    <Input placeholder={t('Search by app client')} />
                </Form.Item>
                <Form.Item
                    label={t('IP Address')}
                    name={'ipAddress'}
                >
                    <Input placeholder={t('Search by IP')} />
                </Form.Item>
                <Form.Item
                    label={t('Path')}
                    name={'path'}
                >
                    <Input placeholder={t('Search by path')} />
                </Form.Item>
                <Form.Item
                    label={t('HTTP Method')}
                    name={'httpMethod'}
                >
                    <Select 
                        allowClear 
                        options={httpMethodOptions} 
                        placeholder={t('Select method')}
                    />
                </Form.Item>
                <Form.Item
                    label={t('Status Code')}
                    name={'statusCode'}
                >
                    <Select 
                        allowClear 
                        options={statusCodeOptions} 
                        placeholder={t('Select status')}
                    />
                </Form.Item>
                <Form.Item
                    label={t('Login Status')}
                    name={'loginStatus'}
                    initialValue={'all'}
                >
                    <Select 
                        options={loginStatusOptions}
                    />
                </Form.Item>
                <Form.Item
                    label={t('Date From')}
                    name={'dateFrom'}
                >
                    <DatePicker style={{width: '100%'}} />
                </Form.Item>
                <Form.Item
                    label={t('Date To')}
                    name={'dateTo'}
                >
                    <DatePicker style={{width: '100%'}} />
                </Form.Item>
            </Form>
        </>
    )
}
